/**
 * A failed organisations-api call, reduced to what the UI needs to pick a message: the HTTP status, the
 * server's message, and whether a 403 was a plan quota denial rather than a permission or email mismatch.
 * `status` is 0 when the request never got a response (e.g. the network is down).
 */
export type OrgApiFailure = {
  status: number;
  message?: string;
  quotaDenied: boolean;
};

export type OrgApiResult = { ok: true } | ({ ok: false } & OrgApiFailure);

export class OrgApiError extends Error {
  public constructor(public failure: OrgApiFailure) {
    super(failure.message || `Request failed with status ${failure.status}`);
  }
}

export function toOrgApiFailure(status: number, body: unknown): OrgApiFailure {
  const message =
    body && typeof body === 'object' && 'message' in body && typeof body.message === 'string'
      ? body.message
      : undefined;

  const extensions =
    body && typeof body === 'object' && 'extensions' in body && body.extensions && typeof body.extensions === 'object'
      ? body.extensions
      : undefined;

  return {
    status,
    message,
    quotaDenied: Boolean(extensions && 'quota_key' in extensions),
  };
}
